// extracted by mini-css-extract-plugin
var _1 = "NgTv9UY0XllQm9rbzYf6";
var _2 = "U0lFWm5IMtaLnNRz_lgu NgTv9UY0XllQm9rbzYf6";
var _3 = "R9Jxm_bmEJ0HJpMTvT6G NgTv9UY0XllQm9rbzYf6";
export { _1 as "navButton", _2 as "nextButton", _3 as "prevButton" }
